import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import SelectList from '../common/inputs/selectList';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import CheckBox from "../common/inputs/checkBox";

const Filters = props => {
  const {
    onChangePeriod,
    periodsData,
    onChangeFilter,
    filterValues,
    selectedMetricGroup,
    metricGroups,
    handleOnChangeMetricGroup,
    metricsDataOptions,
    calculationUnitsData,
    calculationUnitsLoading,
    calculationUnitsFetchAction,
    loadingMetricsDataButton,
    handleLoadMetrics,
    disabledPeriodSelector
  } = props;
  var metricsDataOptionsAux = filterValues["metricsFilter"].length == 0 ? 
    metricsDataOptions :
    metricsDataOptions.filter(item => item.metric_type == filterValues["metricsFilter"][0].metric_type && item.dimension_string == filterValues["metricsFilter"][0].dimension_string)
  ;

  return (
    <div className="metric_data_admin_filters_wrapper">
      <Select
        className="metric_data_admin_filters_wrapper_period_selector"
        disabled={disabledPeriodSelector}
        value={filterValues["periodIdSelected"]}
        onChange={onChangePeriod}
        labelLocale={<FormattedMessage id="common.periodSelectLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(periodsData, "id", "name", false)}
      />
      <Select 
        value={selectedMetricGroup}
        onChange={handleOnChangeMetricGroup}
        labelLocale={<FormattedMessage id="metricDataAdmin.groupSelect"/>}
        options={metricGroups ? [{value: Constants.metricGroups.CUSTOM_METRICS, label: intl.formatMessage({id:"metricAdmin.customMetrics"})}].concat(metricGroups.map(item => { return {value: JSON.stringify(item), label: item.name} })) : []}
      />
      <SelectList        
        values={filterValues["metricsFilter"]}
        onChange={onChangeFilter}
        addSelectLocale={<FormattedMessage id="metricAdmin.addMetricValue"/>}
        labelLocale={<FormattedMessage id="metricAdmin.entityNamePluralFirstUpper"/>}
        noMoreOptionsLocale={intl.formatMessage({id:"metricAdmin.noMoreOptionsMetricsImport"})}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(metricsDataOptionsAux, "id", "name", true, intl.formatMessage({id: "metricAdmin.addMetricValue"}))}
        valueAccesor={"id"}
        labelAccesor={"name"}
        disabled={selectedMetricGroup == Constants.metricGroups.CUSTOM_METRICS ? false : true}
        data-path="metricsFilter"
      />
      <CheckBox 
        className="metric_data_admin_changes_filter"
        id="showMarks"
        data-path="showMarks"
        value={filterValues["showMarks"]}
        onChange={onChangeFilter}
        labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="metricDataAdmin.show_marks"/>)}
      />
      <FetchAutocompleteList        
        values={filterValues["calculationUnitsSelected"]}
        onChange={onChangeFilter}
        addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"calculationsHistory.calculationUnitFilterFinderLabel"}))}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
        valueAccesor={"id"}
        labelAccesor={"name"}
        fetchListAction={calculationUnitsFetchAction}
        loadingFetch={calculationUnitsLoading}
        data-path="calculationUnitsSelected"
      />
      <CheckBox 
        className="metric_data_admin_changes_filter"
        id="hide_inactive_calculation_units"
        data-path="hide_inactive_calculation_units"
        value={filterValues["hide_inactive_calculation_units"]}
        onChange={onChangeFilter}
        labelLocale={LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="metricDataAdmin.hide_inactive_calculation_units"/>)}
      />
      <Button
        disabled={loadingMetricsDataButton || filterValues["metricsFilter"].length == 0}
        loading={loadingMetricsDataButton}
        onClick={handleLoadMetrics}
        labelLocale={<FormattedMessage id="metricDataAdmin.findData"/>}
      />
    </div>
  );
};

export default Filters;



// WEBPACK FOOTER //
// ./source/client/components/metricDataAdmin/filters.jsx